import { render } from "./GitLogin.vue?vue&type=template&id=1f448073&ts=true"
import script from "./GitLogin.vue?vue&type=script&lang=ts"
export * from "./GitLogin.vue?vue&type=script&lang=ts"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__